/** @file useGuide: the guide sheet of one facing, loaded through the sheet flow's cache (null until ready). */
import { useEffect, useState } from 'react';
import type { GuideSheet } from './sheetTypes';

/** `loadGuide(deg)` for the current `deg`; `error` holds the message when it failed; a stale result is dropped. */
export function useGuide(loadGuide: (deg: number) => Promise<GuideSheet>, deg: number): { guide: GuideSheet | null; error: string | null } {
  const [state, setState] = useState<{ deg: number; guide: GuideSheet | null; error: string | null } | null>(null);
  useEffect(() => {
    let live = true;
    loadGuide(deg).then(
      (guide) => { if (live) setState({ deg, guide, error: null }); },
      (e: unknown) => { if (live) setState({ deg, guide: null, error: e instanceof Error ? e.message : String(e) }); },
    );
    return () => { live = false; };
  }, [loadGuide, deg]);
  return state?.deg === deg ? { guide: state.guide, error: state.error } : { guide: null, error: null };
}
